import { Link } from 'react-router-dom';
import Seo from '@/components/Seo';
import { courses, instructors } from '@/data/catalog';

function Instructors() {
  return (
    <>
      <Seo
        title="Instructores"
        description="Perfiles del equipo docente de HFCursos: Helena Ferrer, Mateo Ruiz e Inés Calderón." />

      <section className="mx-auto max-w-6xl px-5 py-12 lg:px-8">
        <p className="text-xs uppercase tracking-[0.28em] text-[#C41E3A]">Equipo</p>
        <h1 className="mt-3 font-['Fraunces'] text-4xl">Instructores</h1>
        


        <ul className="mt-12 space-y-16">
          {instructors.map((person) => {
            const taught = courses.filter((course) => course.instructorId === person.id);
            return (
              <li key={person.id} className="grid gap-8 md:grid-cols-[280px_1fr]">
                <img src={person.photo} alt={`Retrato de ${person.name}`} className="aspect-[3/4] w-full object-cover" />
                <div>
                  <h2 className="font-['Fraunces'] text-3xl">{person.name}</h2>
                  <p className="mt-1 text-sm text-[#C41E3A]">{person.role} · {person.city}</p>
                  <p className="mt-5 max-w-xl text-sm leading-7 text-[#1E3A5F]/75">{person.bio}</p>
                  <p className="mt-6 text-xs uppercase tracking-[0.2em] text-[#1E3A5F]/45">Enfoque</p>
                  <p className="mt-2 text-sm">{person.focus.join(' · ')}</p>
                  <ul className="mt-6 space-y-2">
                    {taught.map((course) =>
                    <li key={course.id}>
                        <Link to={`/cursos/${course.slug}`} className="text-sm underline-offset-4 hover:underline">
                          {course.title}
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </li>);

          })}
        </ul>
      </section>
    </>);

}

export default Instructors;